import { translate } from '@jsverse/transloco';
import { dispatch } from '@ngneat/effects';

import { SecondaryNavKey } from '../../../components/secondary-nav/models/secondary-nav-key';
import { setSecondaryNavOptions } from '../../../components/secondary-nav/repositories/secondary-nav.actions';
import { boolDefinedAndTrue } from '../../../utils/bool-defined-and-true';

export function initSecondaryNavReporting() {
  dispatch(
    setSecondaryNavOptions({
      key: SecondaryNavKey.Reporting,
      options: [
        {
          url: 'reporting/license-tracking',
          displayName: translate('reporting.reporting.licenseTrackingReport'),
          disabled: false,
        },
        {
          url: 'reporting/license-expiry',
          displayName: translate('reporting.reporting.licenseExpiryReport'),
          disabled: false,
        },
      ].filter((option) => !boolDefinedAndTrue(option.disabled)),
    })
  );
}
